import template from './password-recovery.html';
import controller from './password-recovery.controller';
import './password-recovery.scss';

let PasswordRecoveryComponent = {
  bindings: {},
  template,
  controller
};

export default PasswordRecoveryComponent;



// WEBPACK FOOTER //
// ./src/app/pages/password-recovery/password-recovery.component.js